import type { Client } from '@/client';
import { registerAccountHandlers } from './account';
import { registerAdminInteractHandlers } from './admin-interact';
import { registerArenaHandlers } from './arena';
import { registerAttackHandlers } from './attack';
import { registerAvatarHandlers } from './avatar';
import { registerBankHandlers } from './bank';
import { registerBarberHandlers } from './barber';
import { registerBoardHandlers } from './board';
import { registerBossHandlers } from './boss';
import { registerCastHandlers } from './cast';
import { registerChairHandlers } from './chair';
import { registerCharacterHandlers } from './character';
import { registerChestHandlers } from './chest';
import { registerCitizenHandlers } from './citizen';
import { registerConnectionHandlers } from './connection';
import { registerCreationHandlers } from './creation';
import { registerDoorHandlers } from './door';
import { registerEffectHandlers } from './effect';
import { registerEmoteHandlers } from './emote';
import { registerEnchanterHandlers } from './enchanter';
import { registerFaceHandlers } from './face';
import { registerGuildHandlers } from './guild';
import { registerInitHandlers } from './init';
import { registerInstanceHandlers } from './instance';
import { registerItemHandlers } from './item';
import { registerJukeboxHandlers } from './jukebox';
import { registerLockerHandlers } from './locker';
import { registerLoginHandlers } from './login';
import { registerLookupHandlers } from './lookup';
import { registerMarriageHandlers } from './marriage';
import { registerMessageHandlers } from './message';
import { registerMusicHandlers } from './music';
import { registerNpcHandlers } from './npc';
import { registerPaperdollHandlers } from './paperdoll';
import { registerPartyHandlers } from './party';
import { registerPlayersHandlers } from './players';
import { registerPriestHandlers } from './priest';
import { registerQuestHandlers } from './quest';
import { registerRangeHandlers } from './range';
import { registerRatesHandlers } from './rates';
import { registerRecoverHandlers } from './recover';
import { registerRefreshHandlers } from './refresh';
import { registerReputationHandlers } from './reputation';
import { registerSalvageHandlers } from './salvage';
import { registerShopHandlers } from './shop';
import { registerSitHandlers } from './sit';
import { registerSkillHandlers } from './skill';
import { registerSpellHandlers } from './spell';
import { registerStatEffectsHandlers } from './stat-effects';
import { registerStatSkillHandlers } from './stat-skill';
import { registerStatusHandlers } from './status';
import { registerTalkHandlers } from './talk';
import { registerTradeHandlers } from './trade';
import { registerWalkHandlers } from './walk';
import { registerWarpHandlers } from './warp';
import { registerWelcomeHandlers } from './welcome';

export function registerAllHandlers(client: Client): void {
  registerInitHandlers(client);
  registerConnectionHandlers(client);
  registerLoginHandlers(client);
  registerWelcomeHandlers(client);
  registerPlayersHandlers(client);
  registerRecoverHandlers(client);
  registerMessageHandlers(client);
  registerAvatarHandlers(client);
  registerFaceHandlers(client);
  registerWalkHandlers(client);
  registerSitHandlers(client);
  registerChairHandlers(client);
  registerWarpHandlers(client);
  registerRefreshHandlers(client);
  registerNpcHandlers(client);
  registerRangeHandlers(client);
  registerTalkHandlers(client);
  registerAttackHandlers(client);
  registerArenaHandlers(client);
  registerAccountHandlers(client);
  registerCharacterHandlers(client);
  registerDoorHandlers(client);
  registerEffectHandlers(client);
  registerItemHandlers(client);
  registerAdminInteractHandlers(client);
  registerQuestHandlers(client);
  registerMusicHandlers(client);
  registerEmoteHandlers(client);
  registerPaperdollHandlers(client);
  registerChestHandlers(client);
  registerShopHandlers(client);
  registerBoardHandlers(client);
  registerBankHandlers(client);
  registerLockerHandlers(client);
  registerStatSkillHandlers(client);
  registerSpellHandlers(client);
  registerCastHandlers(client);
  registerPartyHandlers(client);
  registerTradeHandlers(client);
  registerBarberHandlers(client);
  registerGuildHandlers(client);
  registerCitizenHandlers(client);
  registerJukeboxHandlers(client);
  registerMarriageHandlers(client);
  registerPriestHandlers(client);
  registerBossHandlers(client);
  registerReputationHandlers(client);
  registerSalvageHandlers(client);
  registerEnchanterHandlers(client);
  registerSkillHandlers(client);
  registerStatusHandlers(client);
  registerInstanceHandlers(client);
  registerRatesHandlers(client);
  registerStatEffectsHandlers(client);
  registerLookupHandlers(client);
  registerCreationHandlers(client);
}
